import { useGroupUserMeData } from "@/data/use-group-user-me-data";
import { GroupRole } from "@/lib/consts";
import { useGroupUuid } from "./use-group-uuid.tsx";

export const useCurrentUserGroupRole = (): GroupRole | null => {
  const groupUuid = useGroupUuid();
  const { groupRole } = useGroupUserMeData(groupUuid);

  return groupRole;
};
